var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M109.678,139.389c2.124,5.113-1.303,11.386-7.66,14.028c-6.35,2.643-13.216,0.644-15.341-4.467 c-2.124-5.111,1.3-11.392,7.65-14.032C100.684,132.276,107.554,134.279,109.678,139.389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M89.249,179.785c-0.088,0.203-0.206,0.366-0.353,0.497c-0.862,0.747-2.961,0.287-4.476-1.459 c-1.287-1.484-1.562-3.205-1.168-4.139c0.087-0.203,0.2-0.366,0.353-0.494c0.862-0.75,2.958-0.284,4.47,1.459 C89.364,177.13,89.642,178.851,89.249,179.785z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M157.786,150.747c0,30.425-24.671,55.096-55.099,55.096c-30.434,0-55.099-24.671-55.099-55.096 c0-30.431,24.665-55.103,55.099-55.103C133.115,95.644,157.786,120.316,157.786,150.747z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M153.364,129.1c5.309,2.214,11.147,3.447,17.262,3.447c24.698,0,44.716-20.018,44.716-44.716 c0-24.685-20.018-44.716-44.716-44.716s-44.716,20.03-44.716,44.716c0,4.907,0.793,9.638,2.252,14.054"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.687,
    y1: 66.35,
    x2: 102.687,
    y2: 94.389
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.687,
    y1: 207.105,
    x2: 102.687,
    y2: 235.137
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 187.08,
    y1: 150.744,
    x2: 159.042,
    y2: 150.744
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.326,
    y1: 150.744,
    x2: 18.293,
    y2: 150.744
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.363,
    y1: 91.068,
    x2: 142.536,
    y2: 110.895
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.832,
    y1: 190.599,
    x2: 43.011,
    y2: 210.419
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.011,
    y1: 91.068,
    x2: 62.838,
    y2: 110.895
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.543,
    y1: 190.599,
    x2: 162.363,
    y2: 210.419
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M68.648,146.58c0,1.243-0.993,2.243-2.237,2.243c-1.237,0-2.243-1-2.243-2.243c0-1.243,1.006-2.243,2.243-2.243 C67.655,144.337,68.648,145.337,68.648,146.58z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M80.89,123.102c-1.15,1.59-2.761,2.38-3.623,1.762c-0.856-0.619-0.637-2.402,0.506-3.995c1.149-1.593,2.768-2.374,3.63-1.759 C82.264,119.725,82.03,121.506,80.89,123.102z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M109.59,116.096c0,1.243-0.993,2.243-2.237,2.243c-1.237,0-2.243-1-2.243-2.243c0-1.243,1.006-2.243,2.243-2.243 C108.597,113.853,109.59,114.852,109.59,116.096z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M133.156,127.656c0,1.243-0.993,2.243-2.237,2.243c-1.237,0-2.243-1-2.243-2.243c0-1.243,1.006-2.243,2.243-2.243 C132.162,125.414,133.156,126.413,133.156,127.656z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M127.027,166.109c-0.416,1.084-2.486,1.287-4.658,0.453c-2.165-0.834-3.583-2.387-3.167-3.467 c0.416-1.084,2.512-1.278,4.673-0.443C126.046,163.485,127.446,165.026,127.027,166.109z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M118.015,184.699c0,1.243-0.993,2.243-2.237,2.243c-1.237,0-2.243-1-2.243-2.243c0-1.243,1.006-2.243,2.243-2.243 C117.022,182.456,118.015,183.456,118.015,184.699z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M140.406,147.914c0,1.243-0.993,2.243-2.237,2.243c-1.237,0-2.243-1-2.243-2.243c0-1.243,1.006-2.243,2.243-2.243 C139.413,145.671,140.406,146.671,140.406,147.914z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M172.046,109.142c-0.15-0.16-0.24-0.331-0.29-0.512c-0.269-1.081,1.106-2.833,3.352-3.567c1.915-0.615,3.583-0.219,4.232,0.503 c0.147,0.153,0.244,0.315,0.287,0.503c0.275,1.081-1.106,2.83-3.358,3.567C174.354,110.267,172.69,109.854,172.046,109.142z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.55,
    y1: 20.863,
    x2: 165.271,
    y2: 43.122
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 237.707,
    y1: 79.673,
    x2: 215.45,
    y2: 82.394
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 212.308,
    y1: 34.71,
    x2: 198.498,
    y2: 52.362
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 117.587,
    y1: 46.262,
    x2: 135.236,
    y2: 60.084
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 206.219,
    y1: 115.618,
    x2: 223.862,
    y2: 129.431
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M181.274,66.185c0.119,0.987-0.568,1.874-1.556,1.993c-0.984,0.122-1.871-0.575-1.996-1.565 c-0.119-0.987,0.581-1.874,1.559-1.996C180.271,64.498,181.152,65.195,181.274,66.185z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M154.931,73.507c0.122,0.981-0.575,1.874-1.562,1.996c-0.981,0.119-1.871-0.578-1.996-1.562 c-0.119-0.99,0.587-1.881,1.559-1.996C153.922,71.82,154.809,72.52,154.931,73.507z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M193.918,84.952c0.113,0.993-1.284,1.968-3.124,2.186c-1.852,0.234-3.436-0.381-3.558-1.368 c-0.122-0.987,1.281-1.959,3.124-2.19C192.207,83.362,193.79,83.965,193.918,84.952z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovid);
export default __webpack_public_path__ + "static/media/covid.b9edc08f0b9a8f918468d950155da50f.svg";
export { ForwardRef as ReactComponent };